import React, { useState } from "react";
import { Dropdown } from "reactstrap";
import { DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import styles from "./profiledropdown.module.scss";
import ArrowDropdown from "../../../../assets/images/arrow-down-dropdown-profile.svg";
import { useNavigate } from "react-router-dom";
import DefaultPicture from "../../../../assets/images/default_user.png";
import { useSelector } from "react-redux";

const ProfileDropdown = ({ openAdminModal }) => {
  const profileInformation = useSelector((state) => state.authReducer);
  const [filterDropdownOpen, setFilterDropdownOpen] = useState(false);
  const navigate = useNavigate();

  const fullName = profileInformation?.name || "";
  const nameParts = fullName?.split(" ");
  const firstName = nameParts?.[0] || "";
  const adminName = firstName ? firstName : "";
  const profileUrl = profileInformation?.profileUrl || "";
  const adminRole = profileInformation?.role || "";
  return (
    <div className={styles["profile_dropdown"]}>
      <Dropdown
        isOpen={filterDropdownOpen}
        toggle={() => {
          setFilterDropdownOpen(!filterDropdownOpen);
        }}
        className={styles["dropdown-container"]}
      >
        <DropdownToggle
          className={`${styles["dropdown_toggle_overlay"]} ${
            filterDropdownOpen ? styles["dropdown_toggle_overlay_open"] : ""
          }`}
        >
          <div className={styles["dropdownToggleDiv"]}>
            <div>
              <img
                src={profileUrl}
                alt="sort"
                width={48}
                height={48}
                style={{
                  borderRadius: "50%",
                  objectFit: "cover",
                }}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = DefaultPicture;
                }}
              />
            </div>
            <div className={styles["paragraphTag"]}>
              <div>
                <p className={styles["mainLabel"]}>{adminName}</p>
              </div>
              <div>
                <p className={styles["subLabel"]}>{adminRole}</p>
              </div>
            </div>
            <div>
              <img src={ArrowDropdown} alt="icon" width={24} height={24} />
            </div>
          </div>
        </DropdownToggle>
        <DropdownMenu className={styles["dropdown_menu"]}>
          <DropdownItem
            onClick={() => {
              navigate(`/${adminRole}/account`);
            }}
            className={styles["dropdown_item"]}
          >
            My Account
          </DropdownItem>
          {adminRole === "admin" && (
            <div>
              <button
                onClick={openAdminModal}
                className={styles["dropdown_button"]}
              >
                Add admin
              </button>
            </div>
          )}
        </DropdownMenu>
      </Dropdown>
    </div>
  );
};

export default ProfileDropdown;
